import { ProfitCalculator } from "./profit-calculator";

export default ProfitCalculator